"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCoreConfig = exports.CoreConfigContext = void 0;
const react_1 = require("react");
exports.CoreConfigContext = (0, react_1.createContext)({
    breakpoint: 1024,
    client: 'desktop',
});
const useCoreConfig = (overrides = {}) => {
    const config = (0, react_1.useContext)(exports.CoreConfigContext);
    Object.entries(overrides).forEach(([key, value]) => {
        if (value === undefined) {
            delete overrides[key];
        }
    });
    return Object.assign(Object.assign({}, config), overrides);
};
exports.useCoreConfig = useCoreConfig;
